module.exports = __webpack_public_path__ + "img/natural_beech_662l_list.f75eaace.jpg";